import { render, staticRenderFns } from "./resource-form-shared.vue?vue&type=template&id=0080e278&scoped=true"
import script from "./resource-form-shared.vue?vue&type=script&lang=ts&setup=true"
export * from "./resource-form-shared.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./resource-form-shared.vue?vue&type=style&index=0&id=0080e278&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0080e278",
  null
  
)

export default component.exports